import { render, staticRenderFns } from "./item-list.vue?vue&type=template&id=1a95f62a&scoped=true"
import script from "./item-list.vue?vue&type=script&lang=js"
export * from "./item-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a95f62a",
  null
  
)

export default component.exports